import { Container } from './styles'

const NotFound = (): JSX.Element => {
  return <Container>Página não encontrada</Container>
}

export default NotFound
